// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"106":"f400428b9654d70ab1c2","628":"d45167f94e4aad975a4c"}[chunkId] + ".js";
};